export const master_defaults = {
    enableFinetuning: false,
};

export const overrides = {
    // example usage:
    // note: need to add REACT_APP_TENANT to .env file
    // csuci: { enableFinetuning: true },
};
